import { z } from 'zod';
import { IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * Order-flow review (2026-10-28) — one row per customer-facing system email
 * the CRM sent or tried to send. Insert-only. See
 * `packages/backend/src/db/schema/sent-email.ts` for the field semantics and
 * `packages/backend/src/notifications/customer-email.ts` for the only writer.
 */
export const SentEmailStatusSchema = z.enum(['sent', 'failed']);
export const SentEmailAttachmentSchema = z.object({
    fileName: z.string(),
    contentType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    /** Lowercase hex sha256 of the exact bytes sent. */
    sha256: z.string().regex(/^[0-9a-f]{64}$/),
    /** Write-once blob path; null when the archive was unavailable. */
    blobPath: z.string().nullable(),
});
export const SentEmailSchema = z.object({
    id: IDSchema,
    type: z.literal('sent_email'),
    schemaVersion: SchemaVersionSchema,
    accountId: z.string(),
    submissionId: z.string().optional(),
    dealId: z.string().optional(),
    contactId: z.string().optional(),
    templateKey: z.string(),
    fromAddress: z.string(),
    toAddresses: z.array(z.string()),
    ccAddresses: z.array(z.string()),
    bccAddresses: z.array(z.string()),
    subject: z.string(),
    bodyHtml: z.string(),
    bodyText: z.string(),
    attachments: z.array(SentEmailAttachmentSchema),
    agreementLabel: z.string().optional(),
    status: SentEmailStatusSchema,
    error: z.string().optional(),
    testMode: z.boolean(),
    mailExternalId: z.string().optional(),
    onceKey: z.string().optional(),
    sentAt: IsoTimestampSchema,
    actor: z.string(),
    correlationId: z.string().optional(),
    createdAt: IsoTimestampSchema,
});
//# sourceMappingURL=sent-email.js.map